
import { page } from "./../src/ts/services/general"

const interval = setInterval(() => {
    let count = 0;
    let counter = document.getElementById("triviaTime");
    if (counter) {
            page()
            clearInterval(interval)
        } else {
            count++
            count == 10 && console.warn('Tapit no ha contestado')
        }
}, 1000);

require(`/src/sass/global.scss`)
